/**
 * Shared pure utilities for the Talent Pool feature.
 *
 * Relocated from the Phase 1 mock service (Phase 3, Plan 03) so that
 * non-hook consumers (AddFromPoolModal, AssignToJobModal, matchLevel.utils)
 * can import from a stable module independent of the phase-1/real service swap.
 *
 * No side-effects, no network calls, no state — pure functions only.
 */

/**
 * Normalize a string to be accent-insensitive for EN/FR search (SCH-02).
 * Maps "Développeur" and "Developpeur" to the same normalized string.
 * No cross-language translation — only diacritic folding.
 */
export const normalizeAccents = (str: string): string =>
  str
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
